<p-toast></p-toast>

<div class="management-shell">
  @if (error()) {
    <div class="error-state">{{ error() }}</div>
  } @else {
    <section class="page-hero">
      <div class="hero-main">
        <div class="entity-logo">
          @if (customer()?.imageUrl) {
            <img [src]="customer()?.imageUrl" [alt]="customer()?.name || 'Customer'" />
          } @else {
            {{ (customer()?.name || 'U').charAt(0) }}
          }
        </div>
        <div>
          <span class="eyebrow">{{ isProfile() ? 'Profile' : 'Employee' }}</span>
          <h1 class="hero-title">Edit Customer</h1>
          <div class="hero-meta">
            <span class="chip">Identity fields locked</span>
          </div>
        </div>
      </div>
      <div class="hero-actions">
        <button pButton type="button" label="Back" icon="pi pi-arrow-left" severity="secondary" [routerLink]="backLink()"></button>
      </div>
    </section>

    <section class="panel mt-3">
      <form [formGroup]="form" class="form-grid" (ngSubmit)="save()">
        <div class="field full">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <app-location-search id="customerLocationSearch" formControlName="searchLocation" (placeSelected)="placeSelect($event)"></app-location-search>
              <label for="customerLocationSearch">Google Maps Search</label>
            </p-iftaLabel>
          </p-inputGroup>
          <span class="locked-hint">Selecting a place updates address, country, name, and available profile image.</span>
        </div>

        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="name" formControlName="name" placeholder=" " />
              <label for="name">Name</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="corporateRole" formControlName="corporateRole" placeholder=" " />
              <label for="corporateRole">Corporate Role</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-image"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="imageUrl" formControlName="imageUrl" placeholder=" " />
              <label for="imageUrl">Image URL</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="countryId" formControlName="countryId" [options]="countries()" optionLabel="name" optionValue="id" [filter]="true" filterBy="name,countryCode" appendTo="body" styleClass="w-full"></p-select>
              <label for="countryId">Country</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="dateOfBirth" type="date" formControlName="dateOfBirth" placeholder=" " />
              <label for="dateOfBirth">Date of Birth</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <select id="gender" formControlName="gender">
                <option value="">Unspecified</option>
                <option value="true">Male</option>
                <option value="false">Female</option>
              </select>
              <label for="gender">Gender</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>

        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-key"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="firebaseId" formControlName="firebaseId" placeholder=" " />
              <label for="firebaseId">Firebase ID</label>
            </p-iftaLabel>
          </p-inputGroup>
          <span class="locked-hint">System identity field.</span>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-envelope"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="emailAddress" formControlName="emailAddress" placeholder=" " />
              <label for="emailAddress">Email</label>
            </p-iftaLabel>
          </p-inputGroup>
          <span class="locked-hint">Email changes require a verified account flow.</span>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="phoneNumber" formControlName="phoneNumber" placeholder=" " />
              <label for="phoneNumber">Phone</label>
            </p-iftaLabel>
          </p-inputGroup>
          <span class="locked-hint">Phone changes require a verified account flow.</span>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="isPhoneVerified" formControlName="isPhoneVerified" placeholder=" " />
              <label for="isPhoneVerified">Phone Verified</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="companyName" formControlName="companyName" placeholder=" " />
              <label for="companyName">Company</label>
            </p-iftaLabel>
          </p-inputGroup>
          <span class="locked-hint">Company assignment is managed separately.</span>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-shield"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="rolesText" formControlName="rolesText" placeholder=" " />
              <label for="rolesText">Access Roles</label>
            </p-iftaLabel>
          </p-inputGroup>
          <span class="locked-hint">Use company role management to change roles.</span>
        </div>

        <div class="form-actions full">
          <button pButton type="button" label="Cancel" severity="secondary" [text]="true" [routerLink]="backLink()"></button>
          <button pButton type="submit" label="Save Customer" icon="pi pi-save" [loading]="isSaving()"></button>
        </div>
      </form>
    </section>
  }
</div>
